import { takeLatest } from "redux-saga/effects";
import * as actionTypes from "./actionTypes";
import {
  addNewNonSaleableReturnSaga,
  editNonSaleableReturnSaga,
  deleteNonSaleableReturnSaga,
} from "./saga";

export default function* watchPhysicalInventory() {
  yield takeLatest(actionTypes.ADD_NEW_NON_SALEABLE_RETURN, addNewNonSaleableReturnSaga);
  yield takeLatest(actionTypes.EDIT_NON_SALEABLE_RETURN, editNonSaleableReturnSaga);
  yield takeLatest(actionTypes.DELETE_NON_SALEABLE_RETURN, deleteNonSaleableReturnSaga);
}